import React from 'react'
import { Link } from 'react-router-dom'

const ForgotPasswordLink = () => (
    <div className="text-center pt-4">
        <Link 
            to="/esqueciSenha" 
            className="text-sm text-indigo-600 hover:text-indigo-700 font-medium transition-colors duration-200 hover:underline"
        >
            Esqueci minha senha
        </Link>
    </div>
)

export default ForgotPasswordLink